import { styled } from '@mui/material'
import MuiCard from '@mui/material/Card'
import { CardProps } from './Card.types'

export const Card = styled(MuiCard)<CardProps>`
  border: thin solid rgba(0, 0, 0, 12%);
`
